<div class="container-fluid">
    <div class="row">

        <div class="col-md-4 mt-4">
            <mat-card class="registerForm">

                <mat-card-header>
                    <mat-card-title>Create New Account</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <form class="example-form" [formGroup]="registerForm">
                        <div class="row">
                            <mat-form-field class="example-full-width col-md-12">
                                <input [(ngModel)]="userNameEmail" matInput placeholder="Client/Company name"
                                    formControlName="client">
                            </mat-form-field>
                            <mat-form-field class="example-full-width col-md-12">
                                <mat-select placeholder="Profession" formControlName="profession">
                                    <mat-option *ngFor="let  profession of professions" [value]="profession.value">
                                        {{ profession.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="example-full-width col-md-12">
                                <input [(ngModel)]="userEmail" matInput placeholder="Email" formControlName="emailid">
                            </mat-form-field>
                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls['emailid'].invalid && registerForm.controls['emailid'].touched">
                                Please enter valid email address
                            </div>

                            <mat-form-field class="example-full-width col-md-12">


                                <input type="password" #input matInput placeholder="Password" formControlName="pass">

                                <mat-icon (click)="showPassword(input)" class="passicon">{{sign}}</mat-icon>


                            </mat-form-field>



                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls['pass'].invalid && registerForm.controls['pass'].touched">
                                Please enter password
                            </div>
                            <mat-form-field class="example-full-width col-md-12">
                                <input type="number" matInput placeholder="Phone number" formControlName="mobile"
                                    class="no-spin">
                            </mat-form-field>
                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls['mobile'].invalid && registerForm.controls['mobile'].touched">
                                Please enter phone number
                            </div>

                        </div>

                        <mat-card-actions>
                            <div class="register">
                                <button class="backTop" [routerLink]="['']" type="button" mat-raised-button
                                    color="primary">Back</button>
                                <button class="ml-4" [disabled]="!registerForm.valid" (click)="onSubmitUser()"
                                    type="button" mat-raised-button color="primary">Create Account</button>


                            </div>
                        </mat-card-actions>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-7">
            <div class="regAdeosImg d-flex justify-content-center align-items-center">
                <img class="" src="assets/images/buildchart.png" />
            </div>
        </div>
    </div>
</div>